<div class="container">
    <div class="row">
        <section class="col-12 col-sm-6 col-md-3 order-1 order-sm-0">
            <p class="sg-heading__h3 my-3">POPULAR</p>

            <mlp-card
                class="mb-3 d-block"
                [blog]="blog"
                [link]="['/blog', blog.slug]"
                cardStyle="lightFont"
                *ngFor="let blog of blogService.blogsPopular"
            >
                <mlp-blog-tags [blog]="blog" maxCategories="3"></mlp-blog-tags>
            </mlp-card>
        </section>

        <section
            class="col-12 col-sm-6 col-md-6 mb-3 order-0 order-sm-1"
            id="mlp-blog-main-content"
        >
            <h1 class="sg-heading__h3 my-3">LATEST SPORTS BLOGS</h1>

            <div *ngIf="blogService.loading">
                <mlp-card>
                    <mlp-loading></mlp-loading>
                </mlp-card>
            </div>

            <article *ngIf="!blogService.loading">
                <mlp-card
                    class="mb-3 d-block"
                    [blog]="blog"
                    [link]="['/blog', blog.slug]"
                    [showDescription]="true"
                    *ngFor="let blog of blogLatestCollection"
                >
                    <mlp-blog-tags
                        [blog]="blog"
                        maxCategories="5"
                    ></mlp-blog-tags>
                </mlp-card>

                <mlp-search-results-pagination
                    [(page)]="blogService.blogsLatestPage"
                    [pageSize]="blogService.blogsLatestPerPage"
                    [collectionSize]="blogService.blogsLatestTotal"
                    [maxSize]="5"
                    (pageChange)="pageChange($event)"
                ></mlp-search-results-pagination>
            </article>
        </section>

        <section class="col-12 col-sm-12 col-md-3 order-2">
            <p class="sg-heading__h3 my-3">FEATURED</p>

            <mlp-card
                class="mb-3 d-block"
                [blog]="blog"
                [link]="['/blog', blog.slug]"
                cardStyle="lightFont"
                *ngFor="let blog of blogService.blogsFeatured"
            >
                <mlp-blog-tags [blog]="blog" maxCategories="3"></mlp-blog-tags>
            </mlp-card>
        </section>
    </div>
</div>
